<template>
  <div>
    <v-row fill-height align="center" justify="center" style="margin:0">
      <!-- <span v-if="units.count == 0">Tidak Ada Data</span> -->
    </v-row>

    <v-row>
      <v-col v-for="item in Tiket" :key="item.id" cols="12" md="6" sm="12">
        <v-card elevation="7" class="mx-auto" outlined>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.code }}</v-list-item-title>
              <v-list-item-subtitle>
                Harga :
                <span style="color: #EF5350">
                  <b>Rp {{ item.harga_beli }}</b></span
                >
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text>
                <span style="color: teal">{{
                  item.id
                }}</span></v-list-item-action-text
              >
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                Created :
                <b> {{ item.created_at | dateTimeFormat }}</b>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Expired :
                <b> {{ item.expired | dateTimeFormat }}</b>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'Tiket',
  props: {
    Tiket: { Array }
  },
  data() {
    return {};
  },
  mounted() {},

  methods: {},
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  }
};
</script>
